export const defaultStyle = {
 navContainer: "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",
  navContent: "navContent block h-screen mt-[100px] bg-antiFlashWhite w-full overflow-y-auto pb-[130px]",
  navItems: "newMobileNav nav-items text-white w-full flex flex-wrap mt-[26px] flex-col gap-[25px] px-[27px]",
  navToggle: "flex items-center mr-[30px] lg:mr-40 absolute h-[88px]",
  navToggleIcon: "cursor-pointer",
  navgationItem: "nav-item uppercase w-full  py-10 border-b-1 pl-15",
}

export const ENG_HEADER_NEW = {
  ...defaultStyle,
  navContainer: "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",
  navContent: "navContent block h-screen mt-[103px] bg-antiFlashWhite w-full overflow-y-auto pb-[60px]",
  navItems: "newMobileNav nav-items text-white w-full flex flex-wrap mt-[26px] flex-col gap-[25px] px-[27px]",
  navToggle: "flex items-center mr-[34px] lg:mr-40 absolute h-[103px]",
  navToggleIcon: "cursor-pointer",
  navgationItem: "nav-item uppercase w-full  py-10 border-b-1 pl-15",
}